import {
  Component, EventEmitter, Output, Input, Injectable, Directive, ElementRef, OnInit, AfterViewInit, HostListener,
  Optional
} from '@angular/core';
import { NgbAlert } from '@ng-bootstrap/ng-bootstrap/alert';
import {
  NgbCalendar,
  NgbDateAdapter,
  NgbDateParserFormatter,
  NgbDatepicker,
  NgbInputDatepicker,
  NgbDateStruct, } from '@ng-bootstrap/ng-bootstrap/datepicker';
import {FormsModule, NgControl} from '@angular/forms';
import { JsonPipe } from '@angular/common';
import IMask from 'imask';
import { isString } from 'imask/esm/core/utils';
import moment from 'moment';
import {NgbTypeahead} from '@ng-bootstrap/ng-bootstrap';

@Directive({
  selector: '[dateMask]'
})
export class DateMaskDirective implements AfterViewInit {
  private mask: InstanceType<typeof IMask.InputMask> | null = null;
  constructor(private el: ElementRef<HTMLInputElement>,
              @Optional() private control: NgControl) { }

  ngAfterViewInit() {
    try {
      if(this.mask)
       return;

      this.mask = IMask(this.el.nativeElement, {
        mask: Date,
        pattern: 'd{.}`m{.}`Y',
        lazy: false,
        overwrite: true,
        autofix: true,
        blocks: {
          d: { mask: IMask.MaskedRange, from: 1, to: 31, maxLength: 2 },
          m: { mask: IMask.MaskedRange, from: 1, to: 12, maxLength: 2 },
          Y: { mask: IMask.MaskedRange, from: 1900, to: 9999, maxLength: 4 }
        }
      });

      // 2. Listen to IMask's 'accept' event and notify Angular's ngModel
      this.mask.on('accept', () => {
        const value = this.mask!.value;

        // Update Angular form control / ngModel if it exists
        if (this.control && this.control.control) {
          this.control.control.setValue(value, { emitEvent: false });
        }

        // Dispatch a native input event so Angular picks up the change
        this.el.nativeElement.dispatchEvent(new Event('input'));
      });
    } catch (error) {
      debugger;
      console.log('Error initializing IMask:', error);
    }

  }

  @HostListener('input')
  onInput() {
    if (this.mask) {
      this.mask.updateValue();
    }
  }
}
@Injectable()
export class CustomAdapter extends NgbDateAdapter<Date | null | undefined> {
  readonly DELIMITER = '.';

  fromModel(value: Date | null | undefined): NgbDateStruct | null {
    if (!value) return null;

    var date = (value instanceof Date) ? value : new Date(value);

    return {
      day: date.getDate(),
      month: date.getMonth() + 1,
      year: date.getFullYear()
    };
  }

  toModel(date: NgbDateStruct | null): Date | null | undefined {
    if (!date) return null;
    return new Date(Date.UTC(date.year, date.month - 1, date.day));
  }
}

/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
  readonly DELIMITER = '.';

  parse(value: string): NgbDateStruct | null {
    if (value && value.indexOf('_') == -1) {
      const date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10),
      };
    }
    return null;
  }

  format(date: NgbDateStruct | null): string {
    if (!date) return '';
    const d = String(date.day).padStart(2, '0');
    const m = String(date.month).padStart(2, '0');
    const y = String(date.year);
    return `${d}.${m}.${y}`;
  }
}

@Component({
  selector: 'Date-Select',
  templateUrl: './DateSelect.html',
  styleUrl: './DateSelect.css',
  imports: [NgbInputDatepicker, NgbAlert, FormsModule, JsonPipe, DateMaskDirective, NgbTypeahead],
  providers: [
    { provide: NgbDateAdapter, useClass: CustomAdapter },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ],

  standalone: true,
})
export class DateSelect {
  @Input() LabelText: string = "";
  @Input() Date: Date | null | undefined = null;
  @Input() MinDate: Date | null | undefined = null;
  @Output() DateChange = new EventEmitter<Date | null | undefined>();
  @Input() enabeld: boolean = true;
  ID: string;


  onBlur(value: string) {
    // Hier den Wert manuell an dein Datenmodell übergeben
    //this.Date = value;
    this.onChange(value);
  }

  onChange(event: any) {



    if ((typeof event === 'string' || event instanceof String) && event.replace(/^_+|_+$/g, '').indexOf('_') > -1)
      this.setDate(null);
    else if (typeof event !== 'string')
      this.setDate(event);
    else if(typeof event === 'string' && (event && event != null && moment(event.replace(/^_+|_+$/g, ''), "DD.MM.YYYY", true).isValid()))
    {
      var date = moment(event.replace(/^_+|_+$/g, ''), "DD.MM.YYYY", true).toDate();

      this.setDate(new Date(Date.UTC(date.getFullYear(), date.getMonth() - 1, date.getDay())));
    }
    else if (!event || event == null)
      this.setDate(null);
  }
  constructor(
    private ngbCalendar: NgbCalendar,
    private dateAdapter: NgbDateAdapter<Date | null | undefined>,

  ) {
    this.ID = "ID" + this.generateRandomString(10);
  }

  get today() {
    return this.dateAdapter.toModel(this.ngbCalendar.getToday())!;
  }

  setToday() {

    this.setDate(this.today);
  }

  setDate(date: Date | null) {

    if (!this.MinDate) {
      this.Date = date;
      this.DateChange.emit(date);
      return;
    }

    var mDate = (this.MinDate instanceof Date) ? this.MinDate : new Date(this.MinDate);

    mDate = new Date(Date.UTC(mDate.getFullYear(), mDate.getMonth(), mDate.getDate()));

    if (!date || date >= mDate) {
      this.Date = date;
      this.DateChange.emit(date);
    }
    else {
      this.Date = mDate;
      this.DateChange.emit(mDate);
    }

  }

  generateRandomString(length: number): string {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';

    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      result += characters.charAt(randomIndex);
    }

    return result;
  }

}
